var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _filter, _filter2, _radialGradient, _linearGradient, _radialGradient2, _linearGradient2, _radialGradient3, _linearGradient3, _radialGradient4, _radialGradient5, _linearGradient4, _radialGradient6, _radialGradient7, _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_400)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_32_400)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#200911"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_radial_32_400)",
    fillOpacity: 0.9
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_400)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80834 25.424C5.86804 36.3629 10.0833 49.9194 22.2398 55.6068C34.3963 61.2941 40.4243 57.6244 45.8859 53.5461C51.3475 49.4678 62.5843 35.1244 52.4549 25.3906C42.3255 15.6569 33.699 21.2885 22.7664 19.9699C18.5421 19.4603 11.7486 14.4851 8.80834 25.424Z",
    fill: "url(#paint1_linear_32_400)",
    fillOpacity: 0.8
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9078 41.9244C57.9864 29.5138 50.791 12.425 36.3851 7.07242C29.6663 4.57606 30.6926 13.8854 22.344 22.1259C13.9954 30.3663 3.30328 43.4887 14.4578 49.1883C25.6123 54.8878 32.2717 47.1664 39.9078 41.9244Z",
    fill: "url(#paint2_radial_32_400)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9078 41.9244C57.9864 29.5138 50.791 12.425 36.3851 7.07242C29.6663 4.57606 30.6926 13.8854 22.344 22.1259C13.9954 30.3663 3.30328 43.4887 14.4578 49.1883C25.6123 54.8878 32.2717 47.1664 39.9078 41.9244Z",
    fill: "url(#paint3_linear_32_400)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9078 41.9244C57.9864 29.5138 50.791 12.425 36.3851 7.07242C29.6663 4.57606 30.6926 13.8854 22.344 22.1259C13.9954 30.3663 3.30328 43.4887 14.4578 49.1883C25.6123 54.8878 32.2717 47.1664 39.9078 41.9244Z",
    fill: "url(#paint4_radial_32_400)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.4589 29.7251C15.36 20.48 15.5159 7.03998 26.0991 7.03998C34.4543 7.03998 41.2799 10.56 45.5946 17.6277C49.9093 24.6953 58.2399 26.1385 58.2399 31.36C58.2399 40.8332 41.5361 45.7904 31.3599 44.8C21.1838 43.8096 9.55792 38.9703 12.4589 29.7251Z",
    fill: "url(#paint5_linear_32_400)",
    fillOpacity: 0.3,
    style: {
      mixBlendMode: "plus-lighter"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4589 29.7251C15.36 20.48 15.5159 7.03998 26.0991 7.03998C34.4543 7.03998 41.2799 10.56 45.5946 17.6277C49.9093 24.6953 58.2399 26.1385 58.2399 31.36C58.2399 40.8332 41.5361 45.7904 31.3599 44.8C21.1838 43.8096 9.55792 38.9703 12.4589 29.7251Z",
    fill: "url(#paint6_radial_32_400)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4327 49.702C35.7465 59.84 52.0665 56 45.0265 47.04C37.9865 38.08 38.2943 38.6812 32.628 32C32.2011 38.4934 31.1189 39.564 33.4327 49.702Z",
    fill: "url(#paint7_radial_32_400)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4327 49.702C35.7465 59.84 52.0665 56 45.0265 47.04C37.9865 38.08 38.2943 38.6812 32.628 32C32.2011 38.4934 31.1189 39.564 33.4327 49.702Z",
    fill: "url(#paint8_linear_32_400)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint9_angular_32_400_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0151279 -0.0324587 0.0341376 0.0159104 32.32 34.24)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -988.559,
    y: -988.559,
    width: 1977.12,
    height: 1977.12
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(250, 168, 170, 0.9687) 0deg,rgba(255, 173, 173, 1) 2.76959deg,rgba(255, 50, 5, 0) 92.9253deg,rgba(255, 240, 224, 0) 205.268deg,rgba(122, 13, 78, 0) 274.405deg,rgba(250, 168, 170, 0.9687) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M8.96003 27.2C1.35139 10.2325 35.2 -3.83998 29.6838 10.4271C24.1675 24.6941 38.1696 47.854 48.0879 30.2613C56.5638 15.2271 16.5687 44.1676 8.96003 27.2Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":0.67916667461395264,\"b\":0.67916667461395264,\"a\":1.0},\"position\":0.0076932958327233791},{\"color\":{\"r\":1.0,\"g\":0.19708330929279327,\"b\":0.020833333954215050,\"a\":0.0},\"position\":0.25812581181526184},{\"color\":{\"r\":1.0,\"g\":0.94441676139831543,\"b\":0.87916666269302368,\"a\":0.0},\"position\":0.57018762826919556},{\"color\":{\"r\":0.47916665673255920,\"g\":0.053906250745058060,\"b\":0.30906248092651367,\"a\":0.0},\"position\":0.76223528385162354}],\"stopsVar\":[],\"transform\":{\"m00\":30.255762100219727,\"m01\":68.275253295898438,\"m02\":-16.945478439331055,\"m10\":-64.917411804199219,\"m11\":31.820760726928711,\"m12\":50.7883300781250},\"opacity\":1.0,\"blendMode\":\"SCREEN\",\"visible\":true}",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter1_f_32_400)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4778 32.1252C51.1241 37.1713 35.0948 36.395 32.7491 43.7701C30.4033 51.1452 12.0283 39.1122 21.0203 32.1252C30.0124 25.1383 14.374 29.02 32.7491 20.4804C51.1241 11.9408 37.8315 27.0791 44.4778 32.1252Z",
    fill: "url(#paint10_radial_32_400)",
    fillOpacity: 0.6
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5456 41.8479C23.68 40.96 20.8 39.36 21.9456 32.2479C23.0912 25.1358 26.9312 26.7358 31.5456 22.6479C36.16 18.56 38.8544 22.1521 42.88 29.76C46.9056 37.3679 39.4112 42.7358 31.5456 41.8479Z",
    fill: "url(#paint11_radial_32_400)"
  })))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_32_400",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8625 0 0 0 0 0.251563 0 0 0 0 0.618125 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_32_400"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945833 0 0 0 0 0.185226 0 0 0 0 0.230862 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_32_400",
    result: "effect2_innerShadow_32_400"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.7375 0 0 0 0 0.94225 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_32_400",
    result: "effect3_innerShadow_32_400"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint9_angular_32_400_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.96003 27.2C1.35139 10.2325 35.2 -3.83998 29.6838 10.4271C24.1675 24.6941 38.1696 47.854 48.0879 30.2613C56.5638 15.2271 16.5687 44.1676 8.96003 27.2Z",
    style: {
      mixBlendMode: "screen"
    }
  })), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_32_400",
    x: 14.5601,
    y: 13.92,
    width: 35.52,
    height: 36.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_32_400"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_32_400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.56 4.16) rotate(63.4457) scale(31.1232 36.9204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA72FF",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344B9D",
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_400",
    x1: 13.661,
    y1: 48.0507,
    x2: 26.4225,
    y2: 27.1409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9777C0",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95BEC",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_32_400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(22.8869 14.6006 -11.7085 25.457 12.5755 29.5604)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1506B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BADE",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32_400",
    x1: 18.5892,
    y1: 15.7072,
    x2: 23.9427,
    y2: 22.4831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C150A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0ADBC",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_32_400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.41016 15.2425 -12.9606 -7.10662 34.1503 32.3412)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6CD",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32_400",
    x1: 50.6726,
    y1: 37.0646,
    x2: 56.9968,
    y2: 24.9666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE518C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665732,
    stopColor: "#EE518C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911525,
    stopColor: "#FF7DAE"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_32_400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.08 31.04) rotate(30.6997) scale(11.909 14.5333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F4791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4791",
    stopOpacity: 0
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_32_400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.2 -15.04 19.2712 -4.05245 41.28 55.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E375DF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91B2"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_32_400",
    x1: 33.4602,
    y1: 34.8164,
    x2: 34.4237,
    y2: 41.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_32_400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7491 32.1252) rotate(90) scale(11.6448 11.7287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165839,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335281,
    stopColor: "#FFD18B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF144D",
    stopOpacity: 0
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_32_400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5456 32.2479) rotate(-180) scale(9.6 9.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165839,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335281,
    stopColor: "#FFD18B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF144D",
    stopOpacity: 0
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a13cc84e9f2b966a219fc745165e9f2.svg";
export { ForwardRef as ReactComponent };